import { Route, Routes } from 'react-router-dom';
import AreaContainer from './containers/AreaContainer';
import VerifyContainer from './containers/VerifyContainer';
import PlanContainer from './containers/PlanContainer';
import FullScreenContainer from './containers/FullScreenContainer';

export default function MainRoute() {
  return (
    <Routes>
      <Route path={'/ai/shipping/f_result/:t_shipping_id'} element={<FullScreenContainer />} />

      <Route path={'/ai/shipping/plan/:mode'} element={<PlanContainer />} />
      <Route path={'/ai/shipping/plan/:mode/:tabIndex'} element={<PlanContainer />} />
      <Route path={'/ai/verify'} element={<VerifyContainer />} />

      <Route path={'/ai/region'} element={<AreaContainer />} />
    </Routes>
  );
}
